import * as api from '../api/authentication';
import { asyncAction } from './common';

export const login = () => asyncAction('LOGIN', api.login());

export const changeUsername = (username) => ({
  type: 'CHANGE_USERNAME',
  username,
});

export const changePassword = (password) => ({
  type: 'CHANGE_PASSWORD',
  password,
});
